import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import * as ContentList from '@/components/ContentList';
import { Modal } from '@/components/Modals';
import ContentItem from '@/modules/corporate/modules/path/views/PathEditor/components/ContentItem';
import { ContentEntity } from '@/types/schema';

import { listStyles } from './styles';

function BlockedAssignmentModal({
  fetching,
  description = 'AssignmentCreator:CantBeAssignedDescription',
  notVisibleContents,
  onClose,
}: {
  fetching?: boolean;
  description?: string;
  notVisibleContents: ContentEntity[];
  onClose: () => void;
}) {
  const { t } = useTranslation();

  return (
    <Modal
      action={{
        text: t('AssignmentCreator:EditAssignment'),
        onSubmit: onClose,
        isSubmitting: fetching,
      }}
      header={{
        title: t('AssignmentCreator:CantBeAssigned'),
        description: t(description, {
          count: notVisibleContents.length,
        }),
        classes: {
          description: 'mb-20',
        },
      }}
      onClose={onClose}>
      <ContentList.Provider
        className={cn('flex flex-1 flex-col ps-20 pe-28')}
        items={notVisibleContents}>
        <ContentList.Items
          renderer={(index: number) => {
            const currentContent = notVisibleContents[index];
            if (!currentContent) {
              return null;
            }

            return (
              <ContentItem
                key={currentContent.id}
                className={cn('border-b border-divider', listStyles)}
                content={currentContent}
              />
            );
          }}
        />
      </ContentList.Provider>
    </Modal>
  );
}

export default BlockedAssignmentModal;
